import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace WorthDataApi {
export const calculate = () => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/worth-data/calculate`,
        
    )
};

export const get = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.WorthNumbersDtoSchema }, 
        `/worth-data`,
        
    )
};

}
